import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { CatMedioPagos, CatCfdiUsos, PersonaClientes, EnviarCorreo, CatRegimenFiscal } from 'app/entidades/entidades';
import { DatosFacturacionCaja } from '../../entidades/entidades';
import { BuscaPersonaClientesService } from "../../servicios/busca-persona-clientes.service";
import { CatRegimenFiscalService } from "../../servicios/cat-regimen-fiscal.service"
import { PersonaClientesService } from "../../servicios/persona-clientes.service";

@Component({
    selector: 'app-datos-facturacion-caja',
    templateUrl: './datos-facturacion-caja.component.html',
    styleUrls: ['./datos-facturacion-caja.component.css']
})
export class DatosFacturacionCajaComponent implements OnInit {

    // public catMedioPagos$ = new EventEmitter<CatMedioPagos>();
    // public catUsoCfdi$ = new EventEmitter<CatCfdiUsos>();


    datosFiscalesForm: FormGroup;
    catMedioPagos: CatMedioPagos[] = [];
    catUsoCfdi: CatCfdiUsos[] = [];
    mediopago = new CatMedioPagos();
    usoCFDI = new CatCfdiUsos();
    regimenFiscal = new CatRegimenFiscal();
    catRegimenFiscal: CatRegimenFiscal[] = [];


    public datosFacturacionCaja$ = new EventEmitter<DatosFacturacionCaja>();
    public datosFacturacion = new DatosFacturacionCaja();

    //  @Output("medioPagosOutput") medioPagosOutput: EventEmitter<MedioPagos>;

    // public personasClientes$ = new EventEmitter<PersonaClientes>();

    public enviaCorreo = new EnviarCorreo();
    public datosenviarCorreo$ = new EventEmitter<EnviarCorreo>();
    personaCliente = new PersonaClientes();

    display1: boolean = false;
    showDialog1() {
        this.display1 = true;
    }

    dontShowDialog() {
        this.display1 = false;
    }

    datos: DatosFacturacionCaja;

    @Input("datosFacturacionCaja") datosFacturacionCaja: DatosFacturacionCaja;
    @Input() PropietarioCuenta: any;


    @Output('catUsoCfdi') catUsoCfdiOutput: EventEmitter<CatCfdiUsos>;
    @Output('catMedioPagos') catMedioPagosOutput: EventEmitter<CatMedioPagos>;
    @Output("personasClientesOutput") personasClientesOutput: EventEmitter<PersonaClientes>;

    constructor(
        private formBuilder: FormBuilder,
        private buscaPersonaClientesService: BuscaPersonaClientesService,
        private catRegimenFiscalService: CatRegimenFiscalService,
        private personaClientesService: PersonaClientesService,

    ) {
        this.catUsoCfdiOutput = new EventEmitter();
        this.catMedioPagosOutput = new EventEmitter();
        this.personasClientesOutput = new EventEmitter();

    }

    ngOnChanges() {
        //console.log('Ya en el comoponenete', this.estadoCuentaInformacionInput)

        if (this.PropietarioCuenta) {
            this.changePropCuenta(this.PropietarioCuenta);
            this.PropietarioCuenta = undefined;

        }
    }


    ngOnInit(): void {
        this.datosFiscalesForm = this.formBuilder.group({
            nombre: [undefined],
            rfc: [undefined],
            email: [undefined],
            regimenFiscal: [undefined],
            cp: [undefined],
        });

        this.asignaForm();


    }
    async asignaForm() {
        /*Asigna FORM*/
        await this.getAllRegimenFiscal();
        if (this.PropietarioCuenta) {
            this.datosFiscalesForm.patchValue({
                razonSocial: this.PropietarioCuenta.razonSocial,
                nombre: this.PropietarioCuenta.nombre,
                rfc: this.PropietarioCuenta.rfc,
                email: this.PropietarioCuenta.correoElectronico,
                regimenFiscal: this.catRegimenFiscal.find((x) => x.id === this.PropietarioCuenta.idRegimenFiscal).descripcion,
                cp: this.PropietarioCuenta.cp
            });
        }
        else if (this.datosFacturacionCaja) {
            // console.log('retorna Datos CAJA ngOnChanges: ', this.datosFacturacionCaja);       
            if (this.datosFacturacionCaja.solicitante) {
                this.datosFiscalesForm.patchValue({
                    nombre: this.datosFacturacionCaja.solicitante,
                    rfc: this.datosFacturacionCaja.rfcSolicitante,
                    email: this.datosFacturacionCaja.emailSolicitante,
                    regimenFiscal: (this.datosFacturacionCaja.idRegimenFiscal) ? (this.catRegimenFiscal.find((x) => x.id === this.datosFacturacionCaja.idRegimenFiscal)).descripcion : null,
                    cp: this.datosFacturacionCaja.cp
                });
                // console.log('SOLICITANTE', this.datosFacturacionCaja.solicitante);
            }
        }
    }

    async childPersonaClientes(personaClientes: PersonaClientes) {
        await this.showDialog1();

        const datosFacturacionCaja = new DatosFacturacionCaja();
        datosFacturacionCaja.emailSolicitante = personaClientes.correoElectronico;
        datosFacturacionCaja.rfcSolicitante = personaClientes.rfc;
        datosFacturacionCaja.idRegimenFiscal = personaClientes.idRegimenFiscal;
        this.enviaCorreo.correo = personaClientes.correoElectronico;
        datosFacturacionCaja.cp = personaClientes.cp;


        if (personaClientes.nombre != null && personaClientes.nombre.length > 0) {
            this.dontShowDialog();
            datosFacturacionCaja.solicitante =
                personaClientes.nombre +
                " " +
                personaClientes.primerApellido +
                " " +
                personaClientes.segundoApellido;
            //console.log("NOMBRE 1222", datosFacturacionCaja.solicitante);
            this.datosFiscalesForm.patchValue({
                nombre: datosFacturacionCaja.solicitante,
                rfc: datosFacturacionCaja.rfcSolicitante,
                email: datosFacturacionCaja.emailSolicitante,
                regimenFiscal: (datosFacturacionCaja.idRegimenFiscal) ? this.catRegimenFiscal.find((x) => x.id === datosFacturacionCaja.idRegimenFiscal).descripcion : null,
                cp: datosFacturacionCaja.cp
            });
        } else {
            datosFacturacionCaja.solicitante = personaClientes.razonSocial;
            //  console.log("NOMBRE", datosFacturacionCaja.solicitante);
            if (datosFacturacionCaja.solicitante && datosFacturacionCaja.rfcSolicitante) {
                this.datosFiscalesForm.patchValue({
                    nombre: datosFacturacionCaja.solicitante,
                    rfc: datosFacturacionCaja.rfcSolicitante,
                    email: datosFacturacionCaja.emailSolicitante,
                    regimenFiscal: (datosFacturacionCaja.idRegimenFiscal) ? this.catRegimenFiscal.find((x) => x.id === datosFacturacionCaja.idRegimenFiscal).descripcion : null,
                    cp: datosFacturacionCaja.cp
                });
            }
        }
        if (personaClientes.rfc != null || personaClientes.rfc === " ") {
            this.dontShowDialog();
            datosFacturacionCaja.rfcSolicitante = personaClientes.rfc;
        } else {
            datosFacturacionCaja.rfcSolicitante = "XAXX010101000";
        }
        if (datosFacturacionCaja.solicitante && datosFacturacionCaja.rfcSolicitante) {


            let personaClienteCajas = new PersonaClientes();
            personaClienteCajas = personaClientes;

            await this.personasClientesOutput.emit(personaClienteCajas);
        }

        await this.datosFacturacionCaja$.emit(datosFacturacionCaja);
        this.datosFacturacion = datosFacturacionCaja;
        this.personaCliente = personaClientes;

    }

    async getUserPublicoGeneral() {
        try {
            const datoRetorno = await this.personaClientesService
                .getSingle(1)
                .toPromise();
            if (datoRetorno) {
                await this.datosFacturacionCaja$.emit(datoRetorno[0]);

                this.personaCliente = datoRetorno;


                this.datosFiscalesForm.patchValue({
                    razonSocial: datoRetorno.razonSocial,
                    nombre: datoRetorno.nombre,
                    rfc: datoRetorno.rfc,
                    email: datoRetorno.correoElectronico,
                    regimenFiscal: this.catRegimenFiscal.find((x) => x.id === datoRetorno.idRegimenFiscal).descripcion,
                    cp: datoRetorno.cp
                });

                await this.personasClientesOutput.emit(this.personaCliente);
            }
        } catch (e) {
          if (e.response) {
            throw { message: e.response.data };
        } else {
            throw e;
        }
        }
    }

    async changePropCuenta(PropietarioCuenta) {
        let nombreCompleto: string;
        if (PropietarioCuenta.nombre)
            nombreCompleto = PropietarioCuenta.nombre;
        if (PropietarioCuenta.primerApellido)
            nombreCompleto += " " + PropietarioCuenta.primerApellido;
        if (PropietarioCuenta.segundoApellido)
            nombreCompleto += " " + PropietarioCuenta.segundoApellido;

        this.datosFiscalesForm.patchValue({
            razonSocial: PropietarioCuenta.razonSocial,
            nombre: nombreCompleto,
            rfc: PropietarioCuenta.rfc,
            email: PropietarioCuenta.correoElectronico,
            regimenFiscal: (PropietarioCuenta.idRegimenFiscal) ? (this.catRegimenFiscal.find((x) => x.id === PropietarioCuenta.idRegimenFiscal)).descripcion : null,
            cp: PropietarioCuenta.cp
        });
    }
    async getAllRegimenFiscal() {
        try {
            const datoRetorno = await this.catRegimenFiscalService.getAll().toPromise();
            this.catRegimenFiscal = datoRetorno;
        } catch (e) {
            if (e.response) {
                throw { message: e.response.data };
            } else {
                throw e;
            }
        } finally {
            console.log("Paso por getAllRegimenFiscal");
        }
    }

}
